var render = function (_h,_vm) {var _c=_vm._c;return _c('span',{class:{ 'grey--text': !+_vm.props.value }},[_vm._v(_vm._s(+_vm.props.value ? _vm.props.value : 0))])}
var staticRenderFns = []

export { render, staticRenderFns }